import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import styles from './style.css'

import { logoMolaIcon } from '@global/imageUrl'
class InfiniteLoader extends React.Component {
  static propTypes = {
    root: PropTypes.string.isRequired, // list container
    onVisible: PropTypes.func, // callback to call when loading is visible
  }

  static defaultProps = {
    onVisible: () => {},
  }

  constructor(prop) {
    super(prop)
    this.lastRef = React.createRef()
  }

  componentDidMount() {
    if (!this.lastRef.current) return
    this.observer = new IntersectionObserver(this.interSectionCallback, {
      threshold: [0, 1],
    })
    this.observer.observe(this.lastRef.current)
  }

  interSectionCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        this.props.onVisible()
      }
    })
  }

  render() {
    return (
      <div ref={this.lastRef} className={`${this.props.className || ''} ${styles.wrapper}`}>
        <img src={logoMolaIcon} />
      </div>
    )
  }
}

export default withStyles(styles)(InfiniteLoader)
